<template>
  <p class="font-medium">
    {{ formattedPrice }}
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { formatIssuers } from '@/modules/pricing/adapter/formatIssuers';
import {
  ContractPricingIssuer,
} from '@/services/requests/users/Users.types';

const { issuers } = defineProps<{
  issuers: ContractPricingIssuer[];
}>();

const formattedPrice = computed(() => formatIssuers(issuers));
</script>
